import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Signal, signal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { SvgComponent } from '../../svg/svg.component';
import { EntityStatus } from '@app/_types/generic.type';
import { entityStatus } from '@app/_datas/const.data';
import { MapService } from '@app/_services/map.service';
import { SettingsService } from '@app/_services/settings.service';
import { InputCheckboxComponent } from '../../inputs/input-checkbox/input-checkbox.component';
import { AnalyticsService } from '@app/_services/analytics.service';

@Component({
    selector: 'app-filter-status',
    imports: [
        CommonModule,
        SvgComponent,
        MatMenuModule,
        InputCheckboxComponent
    ],
    templateUrl: './filter-status.component.html',
    styleUrl: './filter-status.component.scss'
})

export class FilterStatusComponent implements OnInit {

  @Input() value = signal<EntityStatus[]>([]);
  @Input() multiple: boolean = false;
  @Input() label: string = '';
  @Input() hiddenValues: EntityStatus[] = [];
  entityFilterStatus: EntityStatus[] = ['completed', 'incomplete', 'inprogress', 'skipped'];
  entityStatusMap: Signal<Record<EntityStatus, string>> = this.mapService.entityStatusMap;

  // Local optimistic state — updates instantly on click, independent of store propagation
  selectedItems = signal<EntityStatus[]>([]);

  constructor(public ss: SettingsService, private mapService: MapService, private as: AnalyticsService) {

  }

  ngOnInit(): void {
    this.selectedItems.set(this.value());
  }

  getLabel(): string {
    if (this.selectedItems().length === 0) {
      return this.ss.t('common_status');
    } else if (this.selectedItems().length === 1) {
      return this.entityStatusMap()[this.selectedItems()[0]];
    } else {
      return this.selectedItems().length + ' ' + this.ss.t('common_status');
    }
  }

  onStatusSelected(value: EntityStatus, event: MouseEvent): void {
    if (this.multiple) {
      const current = this.selectedItems();
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      // Update local state immediately (optimistic)
      this.selectedItems.set(updated);
      // Update store — triggers data reload in background
      this.value.set(updated);
      event.stopPropagation();
    } else {
      this.selectedItems.set([value]);
      this.value.set([value]);
    }
    this.as.filterEvent('status', value);
  }
}
